export const UPDATE_FEEDBACK = 'UPDATE_FEEDBACK';
export const FEEDBACK_FETCHED = 'FEEDBACK_FETCHED';
